// NotYetAvailable.tsx
import React from "react"
import Image from "next/image"
import { Box, Typography } from "@mui/material"
import { useTranslation } from "@/contexts/LanguageContext"

export default function NotYetAvailable() {
  const { t } = useTranslation()

  return (
    <>
      {/* Background Image */}
      <Box sx={{ position: "fixed", inset: 0, zIndex: -1 }}>
        <Image src="/media/images/login2.avif" alt="Luxury Real Estate" fill style={{ objectFit: "cover" }} priority />
      </Box>

      {/* Glassmorphic Content Box */}
      <Box sx={{ height: "100vh", width: "100vw", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            padding: 2,
            borderRadius: "5px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            maxWidth: 400,
            width: "90%",
            textAlign: "center"
          }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "#fff" }}>
            {t("notYetAvailable.title")}
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, color: "#f0f0f0" }}>
            {t("notYetAvailable.body")}
          </Typography>
        </Box>
      </Box>
    </>
  )
}
